import { Card } from '@lifebit-ai/lds'
import React from 'react'

import { DataAccessRequestParticipantFileDetails } from 'modules/requests/data-access-requests/components/DataAccessRequestParticipantFileDetails'
import { DataAccessRequestParticipantFileStatus } from 'services/results/enums'
import type { DataAccessRequestParticipantFile } from 'services/results/types'
import { CardBody } from 'ui/card/card.styles'

import { DATA_ACCESS_REQUEST_PERSON_ID_FILE_CARD_TEST_ID } from './constants'

interface DataAccessRequestParticipantFileCardProps {
  isDownloadDisabled?: boolean
  isDownloadLoading?: boolean
  participantFile?: DataAccessRequestParticipantFile
  requestId: string
}

export const DataAccessRequestParticipantFileCard = ({
  isDownloadDisabled = false,
  isDownloadLoading = false,
  participantFile,
  requestId
}: DataAccessRequestParticipantFileCardProps): JSX.Element | null => {
  if (participantFile === undefined || participantFile.status === DataAccessRequestParticipantFileStatus.NotRequired) {
    return null
  }

  return (
    <Card data-testid={DATA_ACCESS_REQUEST_PERSON_ID_FILE_CARD_TEST_ID}>
      <CardBody>
        <DataAccessRequestParticipantFileDetails
          hasBorder={false}
          isDownloadDisabled={isDownloadDisabled}
          isDownloadLoading={isDownloadLoading}
          participantFile={participantFile}
          requestId={requestId}
        />
      </CardBody>
    </Card>
  )
}
